export var pmToMd = {
  nodes: {
    blockquote: 'blockquote',
    paragraph: 'paragraph',
    rule: 'hr',
    // lheading (---, ===)
    heading: ['heading', 'lheading'],
    codeBlock: ['code', 'fence'],
    listItem: 'list',
    image: 'image'
  },
  marks: {
    em: 'emphasis',
    strong: 'text',
    link: ['link', 'autolink', 'reference', 'linkify'],
    strike: 'strikethrough',
    code: 'backticks'
  }
};
export var mdToPmSchema = {
  blockquote: {
    block: 'blockquote'
  },
  paragraph: {
    block: 'paragraph'
  },
  em: {
    mark: 'em'
  },
  strong: {
    mark: 'strong'
  },
  link: {
    mark: 'link',
    attrs: function attrs(tok) {
      return {
        href: tok.attrGet('href'),
        title: tok.attrGet('title') || null
      };
    }
  },
  table: {
    block: 'table'
  },
  tr: {
    block: 'tableRow'
  },
  th: {
    block: 'tableHeader'
  },
  td: {
    block: 'tableCell'
  },
  s: {
    mark: 'strike'
  },
  task_list: {
    block: 'taskList'
  },
  task_item: {
    block: 'taskItem',
    attrs: function attrs(tok) {
      return {
        state: tok.meta
      };
    }
  },
  hr: {
    node: 'rule'
  },
  heading: {
    block: 'heading',
    attrs: function attrs(tok) {
      return {
        level: +tok.tag.slice(1)
      };
    }
  },
  softbreak: {
    node: 'hardBreak'
  },
  hardbreak: {
    node: 'hardBreak'
  },
  code_block: {
    block: 'codeBlock'
  },
  list_item: {
    block: 'listItem'
  },
  bullet_list: {
    block: 'bulletList'
  },
  code_inline: {
    mark: 'code'
  },
  ordered_list: {
    block: 'orderedList',
    attrs: function attrs(tok) {
      var order = +(tok.attrGet('order') || 1);
      return {
        order: order
      };
    }
  },
  fence: {
    block: 'codeBlock',
    // we trim any whitespaces around language definition
    attrs: function attrs(tok) {
      var _tok$info;
      return {
        language: ((_tok$info = tok.info) === null || _tok$info === void 0 ? void 0 : _tok$info.trim()) || null
      };
    }
  },
  image: {
    node: 'image',
    attrs: function attrs(_tok) {
      return {};
    }
  },
  media_single: {
    block: 'mediaSingle',
    attrs: function attrs() {
      return {};
    }
  },
  media: {
    node: 'media',
    attrs: function attrs(tok) {
      return {
        url: tok.attrGet('url'),
        type: 'external'
      };
    }
  },
  // Enable ADF SmartLinks, produced by our SmartLink MD plugin
  inlineCard: {
    node: 'inlineCard',
    attrs: function attrs(tok) {
      return {
        url: tok.attrGet('url')
      };
    }
  },
  blockCard: {
    node: 'blockCard',
    attrs: function attrs(tok) {
      return {
        url: tok.attrGet('url')
      };
    }
  },
  embedCard: {
    node: 'embedCard',
    attrs: function attrs(tok) {
      return {
        url: tok.attrGet('url')
      };
    }
  },
  // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
  mention: {
    node: 'mention',
    attrs: function attrs(tok) {
      return {
        id: tok.attrGet('id'),
        text: tok.attrGet('text'),
        type: 'mention'
      };
    }
  },
  status: {
    node: 'status',
    attrs: function attrs(token) {
      return {
        text: token.attrGet('text'),
        color: token.attrGet('color'),
        localId: token.attrGet('localId')
      };
    }
  }
};